import React from 'react'
import IconCard from 'images/ic-card-white.svg'
import { Box, PrecoDe, PrecoPor, Link } from './Styled'

export default function Cartao ({ dados, tipo }) {
  return (
    <Box>
      { dados
        ? <React.Fragment>
          { dados.preco_de ? <PrecoDe>{dados.preco_de}</PrecoDe> : null }
          { dados.preco_por ? <PrecoPor>{dados.preco_por}</PrecoPor> : null }
          <Link tipo={tipo} href={dados.link} target='_blank'>
            <span>Assinar com Cartão</span>
            <img src={IconCard} alt='Pagamento com Cartão' />
          </Link>
        </React.Fragment>
        : null
      }
    </Box>
  )
}
